import {
    ITimeRangeResponse,
    ITimeRangeUpdateRequest,
    TimeRangeUpdateRequest,
} from '@kcftech/prometheustypescriptapiclient';
import { sdClient } from 'contexts/SDKClientContext';

function createUpdateResponse(timeRange: ITimeRangeResponse): ITimeRangeUpdateRequest {
    return {
        Name: timeRange.Name,
        Description: timeRange.Description,
        TimeInSeconds: timeRange.TimeInSeconds,
        IsGlobal: timeRange.IsGlobal,
    };
}

export async function updateTimeRange(
    timeRange: ITimeRangeResponse,
    updates: Partial<ITimeRangeUpdateRequest>
) {
    const initialValue = createUpdateResponse(timeRange);
    return sdClient.updateRange({
        rangeId: timeRange.Id,
        body: new TimeRangeUpdateRequest({ ...initialValue, ...updates }),
    });
}
